import React from "react";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "Starting a complaint",
    paragraphs: ["Email a concise account of the event, relevant order or page, the date discovered, supporting evidence and the outcome requested. Use the order reference rather than card details. Product hazards should be identified at the start so immediate handling guidance can be prioritised."],
  },
  {
    title: "Triage and acknowledgement",
    paragraphs: ["The issue is classified as order, delivery, product, privacy, accessibility, payment, content-rights or site operation. It is then matched to the applicable policy and available record. If essential facts are missing, the reply identifies the specific information needed rather than asking for unrelated personal data."],
  },
  {
    title: "Review and proposed outcome",
    paragraphs: ["The order record, correspondence, product description and supplied evidence are compared. External payment or delivery facts are checked where relevant. The written outcome explains the finding, practical next step and any evidence that could change the result. Safety containment is addressed before a routine financial remedy."],
  },
  {
    title: "Requesting reconsideration",
    paragraphs: ["A customer who disagrees should identify the disputed fact and provide new or overlooked evidence. A second review considers that point without requiring the customer to repeat unrelated material. The internal process does not restrict a complaint to an available consumer, privacy or other authority, or recourse preserved by law."],
  },
  {
    title: "Policy conflict and priority",
    paragraphs: ["A product-specific warning and the accepted order facts control over a general summary. The Privacy Policy controls personal-data handling; Consumer Data Rights controls access and correction requests; the package and return policies control delivery evidence and product remedies. Nothing in a narrower page overrides a mandatory consumer right."],
  },
  {
    title: "Policy changes",
    paragraphs: ["A material revision receives a new effective date. Changes apply prospectively to site use and later orders; they do not rewrite an accepted order or remove a right already acquired. Connected pages are reviewed together when a change affects price, delivery, returns, data or contact information."],
  },
];

export default function Complaints() {
  return <PolicyPage title="Complaints, Disputes & Policy Updates" intro="A single evidence-led route for concerns, reconsideration and coordinated policy changes." sections={sections} related={[["Contact Information", "/contact-policy"], ["Privacy Policy", "/privacy"], ["Returns, Refunds & Exchanges", "/returns"]]} />;
}
